import { defineComponent as _defineComponent } from 'vue'
import CheckboxButton from '@/components/CheckboxButton.vue'
import { computed } from 'vue'
import moment from 'moment-timezone'
import { POS_API_DATETIME_INPUT_FORMAT } from '@/common/constants'


export default /*#__PURE__*/_defineComponent({
  __name: 'AcceptCheckboxButton',
  props: {
  accept: {
    type: Boolean,
    default: false,
  },
  isTransferred: {
    type: Boolean,
    default: false,
  },
  promisedTime: {
    type: String,
    default: null,
  },
},
  emits: ['click'],
  setup(__props) {

const props = __props





const isPromisedTimeToday = computed(() => {
  return moment(props.promisedTime, POS_API_DATETIME_INPUT_FORMAT).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')
})

return { __sfc: true,props, isPromisedTimeToday, CheckboxButton, moment, POS_API_DATETIME_INPUT_FORMAT }
}

})